<app-topheader></app-topheader>
<div class="scrollingcontainer ">
    <div class="bannerimage">
        <img src="{{imagepath}}ACL_EAGLE_SOCIETY.jpg" class="img-fluid" alt="...">
    </div>
    <div class="container">
        <div class="tenpxtop"></div>
        <app-fancy-page-title topTitle="Join Our" subTitle="Eagle Society"></app-fancy-page-title>


        <app-goldbar></app-goldbar>
        <app-current-date></app-current-date>
        <div class="tenpxtop"></div>
        <app-longgoldbar></app-longgoldbar>

        <app-eagle-society-promo></app-eagle-society-promo>
    </div>
</div>
<app-bottommenu></app-bottommenu>